<ng-container *transloco="let t; read: 'user'">
  <div class="p-5">
    <h1 class="pb-2 text-3xl">{{ t('manageEnrollment.sharedProviders.pageTitle') }}</h1>
    <drdp-add-edit-table [dataSource]="dataSource" [tableData]="tableData" [columns]="tableColumns"
      viewIcon="uil uil-file text-drdpblue-300" (deleteActionItem)="deleteModal($event?.data?.id)">
    </drdp-add-edit-table>
    @if (canEdit) {
      <div class="mt-10">
        <drdp-btn (click)="openModal()">
          <i class="uil uil-plus cursor-pointer"></i>
          {{ t('manageEnrollment.sharedProviders.addProvider') }}
        </drdp-btn>
      </div>
    }
  </div>
</ng-container>
